import {
    GetClienteService,
    ListarClientesService,
    GetClienteCompletoService,
    AtualizarClienteService,
    GetClientePorNomeOuEmailService,
    EnviarFormularioEmailServices,
    ComunicarClienteEmLoteService,
    ListarDocumentoTemplateService,
    ListarContaSimplesService,
    ListarClienteComunicadoEmLoteService,
    ListarClientesVendasService,
    ListarClientesRegistraVendaService,
} from "../../../Services/Geral/GestaoClientes/GestaoClientesService";

import {
    IClienteEmLoteFilter,
    IClienteFilter,
    IComunicarClienteEmLoteBody,
} from "../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";

import { IClienteCompleto } from "../../../Interfaces/Geral/Cliente/IClienteSimples";
import { Controller } from "../../Controller";

export async function ListarClientesController(
    page: number,
    idTipoCaso: number,
    filter: IClienteFilter,
    flPaginada?: boolean
) {
    return Controller(
        ListarClientesService(page, idTipoCaso, filter, flPaginada)
    );
}
export async function ListarClientesVendasController(filtro: string) {
    return Controller(ListarClientesVendasService(filtro));
}

export async function ListarClientesRegistraVendaController(
    page: number,
    filter: IClienteFilter
) {
    return Controller(ListarClientesRegistraVendaService(page, filter));
}

export async function ListarClienteComunicadoEmLoteController(
    filter: IClienteEmLoteFilter
) {
    return Controller(ListarClienteComunicadoEmLoteService(filter));
}

export async function ListarClientesSimplesController() {
    return Controller(ListarContaSimplesService());
}

export async function GetClienteController(idConta: number) {
    return Controller(GetClienteService(idConta));
}

export async function GetClienteCompleto(idConta: number) {
    return Controller(GetClienteCompletoService(idConta));
}

export async function GetClientePorNomeOuEmailController(nomeEmail: string) {
    return Controller(GetClientePorNomeOuEmailService(nomeEmail));
}

export async function AtualizarClienteController(
    requestBody: IClienteCompleto,
    atualizarUAU: boolean
) {
    return Controller(AtualizarClienteService(requestBody, atualizarUAU));
}

export const ListarClientesPorNome = (name: string) =>
    ListarClientesController(1, 0, {
        DS_EMAIL: "",
        DS_NOME: name,
        ID_EMPREENDIMENTO: ["0"],
        ID_UNIDADE: 0,
        NR_CPF: "",
        NR_TELEFONE: "",
    }).then((res) => res.LISTA_CLIENTES);

export async function EnviarFormularioEmailController(
    idFormulario: number,
    idConta: number,
    idUnidade: number,
    idDocumentoTemplate: number
) {
    return Controller(
        EnviarFormularioEmailServices(
            idFormulario,
            idConta,
            idUnidade,
            idDocumentoTemplate
        )
    );
}

export async function ComunicarClienteEmLoteController(
    tipoComunicacao: "Email" | "WhatsApp" | "SMS",
    requestBody: IComunicarClienteEmLoteBody,
    idEmailConta?: number
) {
    return Controller(
        ComunicarClienteEmLoteService(
            tipoComunicacao,
            requestBody,
            idEmailConta
        )
    );
}

export async function ListarDocumentoTemplateController() {
    return Controller(ListarDocumentoTemplateService());
}
